import React, { FC } from 'react';
import { NimblePicker as Picker } from 'emoji-mart';
import twitterEmojiData from 'emoji-mart/data/twitter.json';
import 'emoji-mart/css/emoji-mart.css';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const TwemojiSheet64 = require('emoji-datasource-twitter/img/twitter/sheets-256/64.png');

type Props = {
  isVisible: boolean;
  onClick: ({ native }: { native: string }) => void;
};

const EmojiFormWidgetPicker: FC<Props> = ({ isVisible, onClick }) => (
  <Picker
    backgroundImageFn={() => TwemojiSheet64}
    data={twitterEmojiData}
    emoji="point_up"
    onClick={onClick}
    set="twitter"
    sheetSize={64}
    style={{
      bottom: 55,
      opacity: isVisible ? 1 : 0,
      position: 'absolute',
      right: 5,
      transition: '.2s ease-in-out opacity',
      zIndex: isVisible ? 10 : -1,
    }}
    title="Pick your emoji…"
  />
);

export default EmojiFormWidgetPicker;
